// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { customElement, property } from 'lit/decorators.js';
const { sprintf } = _uo.utility;

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.logLoop.i18n;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-loop-header' )
export class AutomatorLogItemLoopHeader extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// Information about what has to be iterated (e.g. users, posts, tokens)
	@property( { type: Object, attribute: false } ) accessor iterableExpression;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="header">
				<div class="header-tag">
					<div class="header-tag-icon">
						<uo-icon id="repeat"></uo-icon>
					</div>

					${ strings.loop }
				</div>

				<div class="header-logic">
					${ this._templateLogicExpression }					
					${ strings.matchTheFollowingCriteria }
				</div>
			</div>
		`;
	}

	/**
	 * Creates the block that shows what type of data we're iterating. E.g. "Users"
	 *
	 * @return {TemplateResult} The expression/source data
	 */
	get _templateLogicExpression() {
		if ( this.iterableExpression.type === 'users' ) {
			return html`
				<div class="header-logic-expression">
					<uo-icon id="user"></uo-icon>
					${ strings.users }
				</div>
			`;
		}

		if ( this.iterableExpression.type === 'posts' ) {
			return html`
				<div class="header-logic-expression">
					<uo-icon id="files"></uo-icon>
					${ strings.posts }
				</div>
			`;
		}

		if ( this.iterableExpression.type === 'iterable-token' ) {
			// We need to use `unsafeHTML` here because it's the only way we can render a token
			// The HTML string is coming from the recipe builder, and was created by us
			return unsafeHTML( this.iterableExpression.value_html );
		}
	}
}